/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Series_FitnessInputs */

const en_ui_chart_series_fitness = /** @type {(inputs: Ui_Chart_Series_FitnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitness (CTL)`)
};

const de_ui_chart_series_fitness = /** @type {(inputs: Ui_Chart_Series_FitnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitness (CTL)`)
};

/**
* | output |
* | --- |
* | "Fitness (CTL)" |
*
* @param {Ui_Chart_Series_FitnessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_series_fitness = /** @type {((inputs?: Ui_Chart_Series_FitnessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Series_FitnessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_series_fitness(inputs)
	return de_ui_chart_series_fitness(inputs)
});